import { Hangtime } from "./Hangtime";
import { HangtimeVideo } from "./HangtimeVideo";
import { Velocity } from "./Velocity";

export const HowDoWeCalculate = {
  Velocity,
  Hangtime,
  HangtimeVideo,
};
